import { logger } from 'lib/logger';

export function sendSassTmrGoal({ goal, value }: { goal: string; value?: number }) {
    logger.info('sass_tmr reachGoal', goal, value);

    if (window._tmr) {
        window._tmr.push({ id: '3547311', type: 'reachGoal', goal, value });
    }
}
